import React, { useState, useEffect, Component } from "react";

const BookingDetails = () => {
    return (<h1>Booking Report Details</h1>);
}

export default BookingDetails;